export const repairForm = {
  title: 'Select a defect',
  defectCaption: 'Choose an issue which you are facing',
  defectOptions: [
    {
      displayValue: 'Purifier not working',
      actualValue: 'Purifier not working',
    },
    {
      displayValue: 'Water is leaking',
      actualValue: 'Water is leaking',
    },
    {
      displayValue: 'Low water flow',
      actualValue: 'Low water flow',
    },
    {
      displayValue: 'Water is not clear',
      actualValue: 'Water is not clear',
    },
    {
      displayValue: 'Unpleasant smell in water',
      actualValue: 'Unpleasant smell in water',
    },
    {
      displayValue: 'Unusual water taste',
      actualValue: 'Unusual water taste',
    },
    {
      displayValue: 'Purifier needs servicing',
      actualValue: 'Purifier needs servicing',
    },
  ],
  remarksLabel: 'Additional Remarks (Optional)',
};

export const bookSlot = {
  selectDateLabel: 'Select date',
  days: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  selectTimeLabel: 'Select time',
  timeSlotError: 'Cannot fetch time slots',
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};
